<template>
  <div class="about-page">
    <main>
      <!-- 海报 -->
      <!-- 主内容 -->
      <div class="m-container">
        <!-- 左侧分页 ？ -->
        <div class="side-left">
          <ul>
            <li v-for="(item, index) in list" :key="index" :class="{ active: isActive == index }" @click="tive(index)">
              {{
                item }}
            </li>
          </ul>
        </div>
        <!-- 右侧内容, 父元素 overflow: hidden; 解决子元素浮动导致的高度塌陷问题，触发 BFC -->
        <ul style="overflow: hidden;">
          <li v-for="(item, index) in content" :key="index" v-show="isActive == index">
            <div class="side-content">
              <h1>{{ content[index].name }}</h1>
              <h2>{{ content[index].title }}</h2>
              <p>{{ content[index].cont1 }}</p>
              <img :class="[content[index].size]" :src="content[index].img" v-show="index === 3">
              <p>{{ content[index].cont2 }}</p>
              <p v-if="content[index].cont3">{{ content[index].cont3 }}</p>
              <p v-if="content[index].cont4">{{ content[index].cont4 }}</p>
              <img :class="[content[index].size]" :src="content[index].img" v-show="index !== 3">
              <img :class="[content[index].size]" v-if="content[index].img2" :src="content[index].img2">
              <img :class="[content[index].size]" v-if="content[index].img3" :src="content[index].img3">
            </div>
          </li>
        </ul>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isActive: 0,
      content: [
        {
          title: this.$store.getters.currentLang === 'zh' ? '字母科技（Acronym Technology）' : ' アクロニムテクノロジ―（Acronym Technology）',
          name: this.$store.getters.currentLang === 'zh' ? '公司概要' : '会社概要',
          cont1: this.$store.getters.currentLang === 'zh' ? '法人：福原 纯' : '法人：福原 純',
          cont2: this.$store.getters.currentLang === 'zh' ? '所在地：〒810-0016福冈县福冈市中央区平和5-13-42' : '所在地：〒810-0016福岡県福岡市中央区平和5-13-42',
          cont3: 'TEL：092-791-7271',
          cont4: 'FAX：092-791-7242',
          size: 'normal-img',
          img: require('../../assets/images/new/big-room1.png')  // ? ../assets/images/about/model.png
        },
        {
          title: this.$store.getters.currentLang === 'zh' ? '九州地区唯一的asp三星认证' : 'H3C Japan様のビジネスパートナーとして、九州地区に承認された唯一なASP三ツ星サービスプロバイダー！',
          name: this.$store.getters.currentLang === 'zh' ? '相关资质' : '関連する資質',
          cont1: '',
          cont2: '',
          size: 'normal-img',
          img: require('../../assets/images/new/certification.jpg')
        },
        {
       
          name: this.$store.getters.currentLang === 'zh' ? '股东' : '役員情報',
          cont1: '',
          cont2: '',
          size: 'big-img',
          img: require('../../assets/images/new/person/fuyuanchun.jpg'),
          img2: require('../../assets/images/new/person/liangbin.jpg'),
          img3: require('../../assets/images/new/person/jianghaoyang.jpg')
        },
        {
          title: '',
          name: this.$store.getters.currentLang === 'zh' ? '相关公司' : '関連会社',
          cont1: this.$store.getters.currentLang === 'zh' ? '鹰空软件集团@苏州' : '鷹空ソフトグループ@蘇州',
          cont2: `株式会社シスパート@日本东京都`,
          size: 'large-img',
          img: require('../../assets/images/new/about-company1.png'),
          img2: require('../../assets/images/new/about-company2.png')
        },
        {
          title: '',
          name: this.$store.getters.currentLang === 'zh' ? '加入我们' : 'JOIN US！',
          cont1: this.$store.getters.currentLang === 'zh' ? '我们的IT公司诚挚地邀请您加入我们的团队！我们是一家专注于技术创新和数字化转型的公司，致力于为客户提供高质量的解决方案和服务 ' : '私達のIT会社は心から私達のチームにあなたを招待します!当社は技術革新とデジタルトランスフォーメーションに特化した会社であり、お客様に高品質のソリューションとサービスを提供することを目指しています ',
          cont2: this.$store.getters.currentLang === 'zh' ? '我们正在寻找具有创造力和热情的人才，与我们一起推动技术的进步 如果您对技术充满热情，并且希望在一个积极向上的团队中发挥您的才能，那么我们非常期待您的加入！' : '私たちと一緒に技術を進歩させる創造的で情熱的な人材を探していますもしあなたが技術に情熱を持っていて、前向きなチームの中であなたの才能を発揮したいなら、私たちはあなたの参加をとても楽しみにしています!',
          size: 'normal-img',
          img: require('../../assets/images/new/big-room1.png')
        }
      ]
    }
  },
  computed: {
    list () {
      return this.$store.getters.currentLang === 'zh' ? ['公司概要', '相关资质', '股东', '相关公司', '加入我们'] : ['会社概要', '関連資格', '役員情報', '関連会社', 'JOIN US！']
    }
  },
  methods: {
    tive (index) {
      this.isActive = index
      // console.log(this.content.length)
      // console.log(this.list.length)
    }
  },
  components: {
  },
}
</script>

<style scoped lang="scss">
// 功能类
li.active {
  color: #172991 !important;
  background: #eeeeee;

  &::before {
    background: url("../../assets/images/about/model01_active.png") no-repeat !important;
  }
}

.about-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  // 内容
  main {
    width: 100%;
    background: #fff;

    > .m-banner {
      width: inherit;
      height: 305px;
      // background: url("../../assets/images/about/banner.png") no-repeat;
    }

    > .m-container {
      margin: 60px auto;
      width: 1000px;

      // 左侧分页
      > .side-left {
        float: left;
        text-align: center;
        min-width: 220px;
        height: 574px;

        // 左侧列表
        > ul {
          width: inherit;
          margin-bottom: 18px;

          > li {
            position: relative;
            left: 20px;
            font-size: 1.4rem;
            color: #999999;
            width: 240px;
            height: 51px;
            line-height: 51px;
            cursor: pointer;
            // &::before {
            //     position: absolute;
            //     top: 10px; left: 27px;
            //     content: "";
            //     display: inline-block;
            //     width: 27px; height: 27px;
            //     background: url("../assets/images/about/model01.png") no-repeat;
            //     background-size: 100% 100%;
            // }
          }
        }

        > p {
          text-align: center;
          margin-bottom: 10px;
        }

        > img {
          width: 130px;
          margin-top: 26px;
          margin-bottom: 15px;
        }
      }

      // 右侧内容
      .side-content {
        margin-left: 50px;
        float: right;
        width: 600px;
        // display: flex;
        // flex-direction: column;
        // justify-content: flex-start;
        // align-items: flex-start;
        flex: 1;
        height: 760px;
        position: relative;

        > h1 {
          margin-top: 8px;
          position: relative;

          &::after {
            content: "";
            display: block;
            width: 48px;
            height: 3px;
            background: #172991;
            position: absolute;
            bottom: -10px;
          }
        }

        > h2 {
          margin-top: 30px;
          margin-bottom: 20px;
        }

        > p {
          font-size: 1.1rem;
          line-height: 30px;
        }
        .large-img {
          width: 600px;
        }
        .big-img {
          max-width: 400px;
        }
        .normal-img {
          max-width: 350px;
        }
        > img {
          margin-top: 30px;
          width: 100%;
          // position: absolute;
          bottom: 0;
        }
      }
    }
  }
}
</style>


